import { compact } from 'lodash/fp'
import { signatureSection } from '../signatureSection'
import signatureDisclaimerSection from '../signatureDisclaimerSection'
import {
  havePayer,
  isEnableEKYCTabs,
  isPayerNeeded,
  isSelectedRemoteSelling,
  isGIOProduct,
  isS7,
  isRemoteSelling,
  isNeedDocCRS,
  isLuckyNumber,
  getAppStatus,
  getSkippedInsuredEkyc,
  getSkippedPayerEkyc,
  isNeedConfirmationLetterSelector,
} from 'e-submission/domain/data-model/form/selectors'
import {
  isInsuredUseCitizenId,
  isInsuredUsePassport,
  isPayerUseCitizenId,
  isPayerUsePassport,
} from 'e-submission/apps/selectors'
import { getLuckyNumberStatus } from 'e-submission/domain/data-model/form/selectors'
import { getToggles } from 'quick-quote/feature-toggles'
import { haveThirdPerson } from 'e-submission/apps/selectors'
import _ from 'lodash'
export const baseAgentRequiredDocs = [
  'BI',
  'APPLICATION',
  'E_POLICY_CONSENT',
  'ADDENDUM',
  'JUVENILE_PURCHASE',
  'FOREIGNER',
  'FNA',
  'VULNERABLE_CUSTOMER',
]

export const signature = (app, props = {}) => {
  const isShowPayerPage = havePayer(app)
  const isHaveThirdPerson = haveThirdPerson(app)
  const hasGIOProduct = isGIOProduct(app)
  const hasS7CCProduct = isS7(app)

  // For RMS v3
  const isNeedConfirmationLetterInsured = isNeedConfirmationLetterSelector('insured', app)
  const isNeedConfirmationLetterPayer = isNeedConfirmationLetterSelector('payer', app)

  const insuredRequiredDocs = [
    'BI',
    'APPLICATION',
    'E_POLICY_CONSENT',
    'PRIVACY_CONSENT',
    'ADDENDUM',
    'JUVENILE_PURCHASE',
    'FOREIGNER',
    'FNA',
    'FATCA',
    getToggles().ENABLE_CRS_SECTION && isNeedDocCRS(app, 'insured') && 'CRS',
    (getToggles().ENABLE_EKYC_F2F || isSelectedRemoteSelling(app)) && 'PASSPORT_CONSENT_INSURED',
    (getToggles().ENABLE_EKYC_F2F || isSelectedRemoteSelling(app)) && 'CITIZEN_ID_CONSENT_INSURED',
    // GIFT
    isNeedConfirmationLetterInsured && 'CONFIRMATION_LETTER_INSURED',
  ]
  const payerRequiredDocs = [
    'APPLICATION',
    'E_POLICY_CONSENT',
    'PRIVACY_CONSENT',
    'ADDENDUM',
    'JUVENILE_PURCHASE',
    'FNA',
    getToggles().ENABLE_CRS_SECTION && isNeedDocCRS(app, 'payer') && 'CRS',
    (getToggles().ENABLE_EKYC_F2F || isSelectedRemoteSelling(app)) && 'PASSPORT_CONSENT_PAYER',
    (getToggles().ENABLE_EKYC_F2F || isSelectedRemoteSelling(app)) && 'CITIZEN_ID_CONSENT_PAYER',
    // GIFT
    isNeedConfirmationLetterPayer && 'CONFIRMATION_LETTER_PAYER',
  ]
  let acknowledgeRequiredDocs = [
    'PRIVACY_POLICY',
    getToggles().ENABLE_CITIZEN_ID_CONSENT_FORM && isInsuredUseCitizenId(app)
      ? 'CITIZEN_ID_CONSENT_INSURED'
      : undefined,
    getToggles().ENABLE_CITIZEN_ID_CONSENT_FORM && isInsuredUsePassport(app) ? 'PASSPORT_CONSENT_INSURED' : undefined,
    getToggles().ENABLE_CITIZEN_ID_CONSENT_FORM && isPayerUseCitizenId(app) ? 'CITIZEN_ID_CONSENT_PAYER' : undefined,
    getToggles().ENABLE_CITIZEN_ID_CONSENT_FORM && isPayerUsePassport(app) ? 'PASSPORT_CONSENT_PAYER' : undefined,
  ]

  if ((getToggles().ENABLE_EKYC_F2F || isSelectedRemoteSelling(app)) && !isRemoteSelling(app)) {
    acknowledgeRequiredDocs = acknowledgeRequiredDocs.filter((docs) => docs === 'PRIVACY_POLICY')
  }

  const overrideDescription =
    hasGIOProduct || hasS7CCProduct
      ? {
          APPLICATION: 'ใบคำขอเอาประกันชีวิต',
        }
      : {
          APPLICATION: 'ใบคำขอเอาประกันภัย ประเภทสามัญชนิดทั่วไป',
        }

  const insuredSignatureSection = signatureSection('insured', compact(insuredRequiredDocs), overrideDescription)

  const agentSignatureSection = signatureSection('agent', baseAgentRequiredDocs, overrideDescription)

  const payerSignatureSection = signatureSection('payer', compact(payerRequiredDocs), overrideDescription)

  const acknowledgeSignatureSection = signatureSection('acknowledge', compact(acknowledgeRequiredDocs))
  const thirdPersonSignatureSection = signatureSection('thirdPerson', ['FNA'])

  const isInsuredEnableEKYC = isEnableEKYCTabs(app, 'insured')
  const isPayerEnableEKYC = isPayerNeeded(app) ? isEnableEKYCTabs(app, 'payer') : true
  const isEnableEKYCSteps = isInsuredEnableEKYC && isPayerEnableEKYC

  const isShowLuckyNumber = isLuckyNumber(app)
  const isDisabledLuckyNumberSteps = isShowLuckyNumber && !getLuckyNumberStatus(app)

  return Object.assign(
    {},
    {
      id: 'signature',
      prefix: 'signature',
      title: 'ลงนาม',
      label: 'ลงนาม',
      disabled: !isEnableEKYCSteps || isDisabledLuckyNumberSteps,
      sections: compact([
        insuredSignatureSection('insured', 'ลงนาม ผู้เอาประกันภัย'),
        isShowPayerPage && payerSignatureSection('payer', 'ลงนาม ผู้ชำระเบี้ย'),
        agentSignatureSection('agent', 'ลงนาม ตัวแทน/นายหน้าประกันชีวิต'),
        isHaveThirdPerson && thirdPersonSignatureSection('thirdPerson', 'ลงนาม บุคคลที่สาม'),
        getToggles().ENABLE_PDPA_CONSENT && acknowledgeSignatureSection('acknowledge', 'ตรวจทานเอกสาร'),
        signatureDisclaimerSection('disclaimer'),
      ]),
      lastPage: true,
    },
    props
  )
}
